<template>
  <div>
    <footer class="footer">
      <div class="footTitle" v-if="showSearch">
        <div class="footTitleLeft">
          <p class="p1">收款订单列表（我的收入）</p>
        </div>
        <div class="footTitleRight">

        </div>
      </div>
      <div v-else style="margin-bottom: 10px;text-align: center;display: flex;">
        <div style="margin-right: 2rem;">
          <el-button @click="addCollection1()" style="padding: 0.1rem 0.2;" size="mini"
            type="primary">生成新的收款确认单</el-button>
        </div>
        <div>
          <el-button @click="handlerSeeOrderClick1()" style="padding: 0.1rem;width: 5rem;" size="mini"
            :type="dialogVisible1 ? '' : 'primary'">已生成的操作及收费确认单</el-button>
          <el-button @click="handlerSeeOrderClick1()" style="padding: 0.1rem;width: 5rem;" size="mini"
            :type="dialogVisible1 ? 'primary' : ''">收款列表</el-button>
        </div>
      </div>
      <div style="border: 1px solid #ebeef5" v-show="!dialogVisible1">
        <el-table border :header-cell-style="{ backgroundColor: '#FDEFE7', color: '#000000' }" ref="multipleTable"
          :data="tableData" tooltip-effect="dark" style="width: 100%" show-summary :summary-method="getSummaries">
          <el-table-column align="center" type="selection" width="55"> </el-table-column>
          <el-table-column width="180" prop="id" align="center" label="收款确认单编号">
            <template slot-scope="scope">
              <p v-if="scope.row.collectionType==4"><el-tag type="success">自定义收款</el-tag></p>
              <p><a @click="editCollection(scope.row)" style="color:blue">{{ scope.row.id }}</a></p>
            </template>
          </el-table-column>
          <el-table-column width="180" prop="planId" align="center" label="行程编号"> </el-table-column>
          <el-table-column width="150" align="center" label="下单时间">
            <template slot-scope="scope"> {{ scope.row.createTime | dateFormatHms }} </template>
          </el-table-column>
          <el-table-column width="180" prop="chargingContent" align="center" label="收款内容">
          </el-table-column>
          <el-table-column width="180" prop="contain" align="center" label="费用包含"> </el-table-column>
          <el-table-column width="100" prop="feeAmount" align="center" label="确认单金额">
            <template slot-scope="scope">
              {{ scope.row.feeAmount }}{{ scope.row.currency }}
            </template>
          </el-table-column>
          <el-table-column width="70" prop="payNumber" align="center" label="付款人数"> </el-table-column>
          <el-table-column width="100" prop="payPriceInCome" align="center" label="应收总金额">
          </el-table-column>
          <el-table-column width="100" prop="payPrice" align="center" label="实收总金额">
            <template slot-scope="scope">
              <a @click="handlerSeeOrderClick(scope.row)">{{ scope.row.payPrice}}</a>
            </template>
          </el-table-column>
          <el-table-column width="100" prop="refusePrice" align="center" label="退款金额"> </el-table-column>
          <el-table-column width="100" prop="serviceCharge" align="center" label="手续费"> </el-table-column>
          <el-table-column width="100" align="center" label="最终实收">
            <template slot-scope="scope">
              {{ scope.row.payPrice - scope.row.refusePrice - scope.row.serviceCharge }}
            </template>
          </el-table-column>
          <el-table-column width="260" align="center" label="操作" fixed="right">
            <template slot-scope="scope">
              <div style="display: flex; align-items: center;">
                <svg-icon :iconClass="'qrCode'" style="width:0.5rem" v-if="scope.row.currency == '￥'"
                  @click="seeQrCode(scope.row)"></svg-icon>
                <el-button @click="handlerSeeOrderClick(scope.row)" style="padding: 0.07rem 0.05rem;" size="mini"
                  type="primary">收款详情</el-button>
                <el-button @click="addUnderLinePay(scope.row)" size="mini" style="padding: 0.07rem 0.05rem;"
                  type="primary">{{ scope.row.collectionDetailList.length > 0 ? '再次生成应收' : '生成应收' }}</el-button>
                <el-button v-if="!scope.row.collectionDetailList.length > 0" @click="deleteCollection(scope.row)"
                  size="mini" style="padding: 0.07rem 0.05rem;" type="primary">删除</el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <pagination :totalNumber="totalNumber" @loadTable="loadTable"></pagination>
      </div>
      <div v-show="dialogVisible1">
        <div style="margin-bottom: 0.1rem; text-align: right;">
          <el-button size="mini" type="primary" @click="dialogVisible1 = false">← 返回列表</el-button>
        </div>
        <div class="collection-line" style="display: flex;margin-bottom: 0.1rem;align-items: end;">
          <div>
            <span class="totalPrice" v-if="detailListObj.totalPrice > 0">应收总金额：<span>¥{{
              detailListObj.totalPrice.toFixed(2)
                }}</span></span>
            <span class="totalPrice">待到账总金额：<span>¥{{ detailListObj.noIncomePirce
                }}</span></span>
            <span class="totalPrice" v-if="detailListObj.incomePrice > 0">已到账总金额：<span>¥{{
              (detailListObj.totalPrice - detailListObj.noIncomePirce).toFixed(2) }}</span></span>
            <span class="totalPrice" v-if="detailListObj.refurePrice > 0">退款总金额：<span>¥{{ detailListObj.refurePrice
                }}</span></span>
            <span class="totalPrice" v-if="detailListObj.refureingPrice > 0">退款中总金额：<span>¥{{
              detailListObj.refureingPrice
                }}</span></span>
            <span class="totalPrice" v-if="detailListObj.taxPrice > 0">手续费总金额：<span>¥{{
              detailListObj.taxPrice.toFixed(2)
                }}</span></span>
            <span class="totalPrice" v-if="detailListObj.incomePrice > 0">实收金额（到账-退款-手续费）：<span>¥{{
              (detailListObj.incomePrice).toFixed(2) }}</span></span>
            <span class="totalPrice" v-if="detailListObj.waitIncomePrice > 0">已到账未结算总金额：<span>¥{{
              detailListObj.waitIncomePrice }}</span></span>
          </div>
        </div>
        <div style="margin-bottom: 0.1rem;" class="searchDiv">
          <el-select v-model="detailSearchObj.status" placeholder="到账状态" size="mini" style="width:80px">
            <el-option label="已到账" :value="1"></el-option>
            <el-option label="未到账" :value="2"></el-option>
          </el-select>
          <el-button size="mini" @click="serachList">搜索</el-button>
        </div>
        <el-table border :header-cell-style="{ backgroundColor: '#FDEFE7', color: '#000000' }" ref="multipleTable"
          :data="detailList" tooltip-effect="dark" style="width: 100%">
          <el-table-column align="center" type="selection" width="55"> </el-table-column>
          <el-table-column width="150" align="center" label="收款时间">
            <template slot-scope="scope"> {{ scope.row.payDate | dateFormatHms }} </template>
          </el-table-column>
          <el-table-column width="250" prop="payName" align="center" label="付款方名称"> </el-table-column>
          <el-table-column width="100" prop="payPrice" align="center" label="收款金额">
            <template slot-scope="scope">
              <span v-if="scope.row.status != 5" style="color:blue">¥{{ scope.row.payPrice }}</span>
              <span v-else style="color:red">-¥{{ scope.row.payPrice }}</span>
            </template>
          </el-table-column>
          <el-table-column width="100" align="center" label="付款方式">
            <template slot-scope="scope"> {{ scope.row.payType == 1 ? '微信' : '线下转账' }} </template>
          </el-table-column>
          <el-table-column width="200" align="center" label="备注">
            <template slot-scope="scope"> 
              <a v-if="!scope.row.remark||scope.row.remark==''" style="color:blue" @click="uploadFile(scope.row,['remark'])">编辑备注</a> 
              <span v-else>{{ scope.row.remark }}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" width="130" label="是否到账">
            <template slot-scope="scope">
              <span style="color:blue" v-if="scope.row.status==3||scope.row.status==4" @click="selectRefuse(scope.row)">{{scope.row.status==3?'退款中':'已退款'}}</span>
              <span  style="color:blue" v-else-if="scope.row.status==10" @click="goTransferOutManagement(scope.row)">已转出</span>
              <span v-else>{{ scope.row.status == 1 || scope.row.status == 5 || scope.row.status == 6 ? '已到账' : '未到账' }} </span>
              <span v-if="scope.row.status == 3 || scope.row.status == 4">¥{{
                scope.row.refundPrice == 0 ? scope.row.payPrice : scope.row.refundPrice }}</span>
              <p v-if="scope.row.refundDate">{{ scope.row.refundDate | dateFormatHms }} </p>
            </template>
          </el-table-column>
          <el-table-column width="100" align="center" label="已开票金额">
            <template slot-scope="scope">
              {{ scope.row.invoicePrice ? '¥' + scope.row.invoicePrice : '未开票' }}
            </template>
          </el-table-column>
          <el-table-column align="center" label="操作">
            <template slot-scope="scope">
              <el-button type="primary" v-if="scope.row.status == 1" style="padding: 0.05rem 0.05rem;"
                @click="collectionToOther(scope.row)">转出</el-button>
              <el-button type="primary" v-if="scope.row.status == 1" style="padding: 0.05rem 0.05rem;"
                @click="refurePay(scope.row)">退款</el-button>
              <el-button type="primary" v-if="scope.row.status == 0&&!Number(scope.row.invoicePrice) > 0" style="padding: 0.05rem 0.05rem;"
                @click="deleteDetailData(scope.row)">删除</el-button>
              <el-button type="primary" v-if="scope.row.status == 0" style="padding: 0.05rem 0.05rem;"
                @click="uploadFile(scope.row,[])">编辑</el-button>
              <el-button type="primary" v-if="((Number(scope.row.payPrice) - Number(scope.row.invoicePrice)) > 0)"
                style="padding: 0.05rem 0.05rem;" @click="invoiceClick(scope.row)">开发票</el-button>
              <!-- <div v-else>
                已开票金额{{ scope.row.invoicePrice }}¥
              </div> -->
              <el-button type="primary" v-if="Number(scope.row.invoicePrice) > 0" style="padding: 0.05rem 0.05rem;"
                @click="goinvoiceList(scope.row)">发票详情</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </footer>
    <add-under-line-pay ref="addUnderLonePay" @getList="getList"></add-under-line-pay>
    <invoicePopup :detailId="detailId" :orderList="detailList.map(n => ({
      ...n,
      payPrice: n.payPrice - n.refundPrice
    }))" :state="1" @update="getList($event)" ref="invoicePopup">
    </invoicePopup>
    <el-dialog title="确认单收款二维码" :visible.sync="dialogVisible3" :append-to-body="true" width="30%">
      <div v-if="text" style="display: flex;">
        <div class="erWeimaBox">
          <Qr style="text-align: center;display: flex;margin-left: 120px;" :bgSrc="bgSrc" :logoSrc="logoSrc"
            :text="text">
          </Qr>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible3 = false">取 消</el-button>
      </span>
    </el-dialog>
    <collection-new ref="addCollection" @refresh="getList"></collection-new>
    <el-dialog title="退款申请" :visible.sync="dialogVisible2" :append-to-body="true" width="30%">
      <div class="payRequestContent">
        <div v-if="refuceObj.payType==2">
          <p>
            <span><span style="color:red">*</span>收款方名称&nbsp;&nbsp;</span>
            <el-input v-model="refuceObj.payName" placeholder="请输入内容"></el-input>
          </p>
          <p>
            <span><span style="color:red">*</span>收款银行名称&nbsp;&nbsp;</span>
            <el-input v-model="refuceObj.payBankName" placeholder="请输入内容"></el-input>
          </p>
          <p>
            <span><span style="color:red">*</span>收款账户&nbsp;&nbsp;</span>
            <el-input v-model="refuceObj.payBankNumber" placeholder="请输入内容"></el-input>
          </p>
        </div>
        <p>
          <span><span style="color:red">*</span>退款金额&nbsp;&nbsp;</span>
          <el-input v-model="refuceObj.price" placeholder="请输入内容"></el-input>
        </p>
        <p>
          <span><span style="color:red">*</span>退款原因&nbsp;&nbsp;</span>
          <el-input v-model="refuceObj.remark" placeholder="请输入内容"></el-input>
        </p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible2 = false">取 消</el-button>
        <el-button type="primary" @click="refuceSure">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="退款查询" :visible.sync="refuseSelectDialiog" :append-to-body="true" width="80%">
      <refuse-request ref="refuseRequest" :isDialog="true"></refuse-request>
    </el-dialog> 
     <el-dialog title="收款转出" :visible.sync="collectionToOtherDialog" :append-to-body="true" width="45%">
      <div class="payRequestContent">
        <p>
          <el-radio v-model="zhuanRadio" :label="1">转出到其他团</el-radio>
          <el-radio v-model="zhuanRadio" :label="2">转出到余额钱包</el-radio>
        </p>
        <div v-if="zhuanRadio==1">
          <p>请输入你要转出的团号：<el-input style="width:100px;margin-top:10px" size="mini" v-model="zhuanPlanId" @change="changeZhuanPlanId"></el-input></p>
          <plan-list-info v-if="zhuanPlanObj&&zhuanPlanObj.id" :item="zhuanPlanObj" :isLook="true"></plan-list-info>
          <p style="color:red;font-size:18px;" v-if="zhuanPlanObj&&!zhuanPlanObj.id">查询不到你输入的团信息，请重新输入</p>
        </div>
        <p>
          <el-input style="width:400px;margin-top:10px" size="mini" v-model="zhuanRemark" placeholder="请输入转出理由"></el-input>
        </p>
        <p style="color:red">注：请仔细核对信息是否正确，一旦转出不可修改</p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible2 = false">取 消</el-button>
        <el-button type="primary" @click="collectionToOtherSure">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import PayApi from "@/components/Api/pay";
import ApplyApi from "@/components/Api/apply";
import OrderApi from '@/components/Api/order'
import PlanApi from '@/components/Api/PlanApi.js'
import Pagination from '../../../../../components/Pagination.vue';
import Qr from "@/components/Qr.vue";
import AddUnderLinePay from './dialog/addUnderLinePay.vue';
import collection from '../../../../plan/leftMoudle/dialog/collection.vue';
import invoicePopup from "./expendChild/invoicePopup.vue";
import RefuseRequest from '../../../refuseRequest.vue';
import PlanListInfo from '../../../../plan/rightPopup/trip/child/planListInfo.vue';
import CollectionNew from "../../../../plan/leftMoudle/dialog/collectionNew";
export default {
  components: {CollectionNew, Pagination, Qr, AddUnderLinePay, collection, invoicePopup, RefuseRequest, PlanListInfo },
  computed: {
    shouldShowInvoiceButton() {
      return row => {
        const noInvoice = !row.invoiceNumber;
        const statusCondition = [1, 0, 3, 4].includes(row.status);
        const refundCondition = row.status == 4 && row.refundPrice != row.payPrice;
        return noInvoice && (statusCondition || refundCondition);
      };
    }
  },
  data() {
    return {
      tableData: [],
      page: 1,
      size: 20,
      totalNumber: 0,
      detailList: [],
      logoSrc: require("@/assets/png/planQRLogo.png"),
      bgSrc: "",
      detailListObj: {
        totalPrice: 0,
        incomePrice: 0,
        noIncomePirce: 0,
        refurePrice: 0,
        taxPrice: 0,
        refureingPrice: 0,
        waitIncomePrice: 0,
      },
      detailSearchObj: {
        status: null,
      },
      dialogVisible1: false,
      user: {},
      text: '',
      detailId: null,
      dialogVisible2: false,
      collectionToOtherDialog:false,
      zhuanRadio:null,
      zhuanPlanId:null,
      zhuanPlanObj:null,
      zhuanRemark:null,
      zhuanPlanCollectionId:null,
      refuceObj: {
        id: null,
        payBankName: null,
        payBankNumber: null,
        payName: null,
        remark: null,
      },
      dialogVisible3: false,
      chenckBudget: {},
      refuseSelectDialiog:false,
    }
  },
  props: {
    showSearch: {
      default: true,
      type: Boolean
    },
    planId: {
      default: null,
      type: Number,
    }
  },
  mounted() {
    if (this.showSearch) {
      this.getList()
    }
  },
  methods: {
    collectionToOther(item){
      this.collectionToOtherDialog = true
      this.zhuanPlanCollectionId = item.id
    },
    goTransferOutManagement(row) {
      const targetRoute = this.$router.resolve({
            name: 'myDeal',
            query: {
                  currentComponent: 'transferOutManagement',
                  httpObj: JSON.stringify({ fromCollectionId: row.id })
            }
          });
          window.open(targetRoute.href, '_blank');
    },
    collectionToOtherSure(){
      if(this.zhuanRadio==1){
        if(!(this.zhuanPlanObj&&this.zhuanPlanObj.id)){
          this.$message.error("请先输入正确的团号数据")
          return;
        }
      }
      //请求接口
      new PayApi("pay").changeColletionPlanId({ 
        collectionId: this.zhuanPlanCollectionId,
        changeType:this.zhuanRadio,
        planId:this.zhuanPlanId,
        remark:this.zhuanRemark
      }).then(res => {
        if (res.status == 200) {
          this.$message.success("转出审核发送成功")
          this.collectionToOtherDialog = false
          this.sendMessageToWechat(res.pid)
          this.getList()
        }else{
          this.$message.error(res.statusText)
        }
      })
    },
    changeZhuanPlanId(){
      new PlanApi('plan').planList({page:1,size:10,q:{keyword:this.zhuanPlanId}}).then(res => {
        if(res.data.records.length>0){
          this.zhuanPlanObj = res.data.records[0]
        }else{
          this.zhuanPlanObj={}
        }
      })
    },
    selectRefuse(item){
      this.refuseSelectDialiog = true
      this.$nextTick(() => {
        this.$refs.refuseRequest.searchObj.procureOrderNumber = item.id
        this.$refs.refuseRequest.changeStatus(0)
      })
    },
    seeQrCode(item) {
      this.dialogVisible3 = true
      if (this.text == '') {
        new PayApi("pay").getCiphertext({ id: item.id }).then(res => {
          if (res.status == 200) {
            this.text = process.env["VUE_APP_INVOICE_H5_SERVE"] + `?type=2&collectionId=${item.id}&ciphertext=${res.data}`
          }
        })
      }
    },
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      var yingshou = 0
      var shishou = 0;
      var refusePrice = 0;
      var shouxufei = 0;
      var shijishou = 0;
      this.tableData.forEach(ee => {
        yingshou = yingshou + ee.payPriceInCome
        shishou = shishou + ee.payPrice
        refusePrice = refusePrice + ee.refusePrice
        shouxufei = shouxufei + ee.serviceCharge
        shijishou = shijishou + (ee.payPrice - ee.refusePrice - ee.serviceCharge)
      })
      sums[0] = '总计'
      sums[8] = yingshou
      sums[9] = shishou
      sums[10] = refusePrice
      sums[11] = shouxufei
      sums[12] = Number(shijishou.toFixed(2))
      return sums;
    },
    editCollection(item) {
      this.$refs.addCollection.beforeOpen(item)
    },
    addCollection1() {
      this.$refs.addCollection.init(this.chenckBudget)
    },
    //已开票 跳转到发票列表
    goinvoiceList(row) {
      if (this.$route.name === "myDeal") {
        let obj = {
          currentComponent: 'invoiceManager',
          httpObj: { orderNumber: row.id }
        }
        this.$Bus.$emit('pagesSW', obj);
      } else {
          const targetRoute = this.$router.resolve({
            name: 'myDeal',
            query: {
                  currentComponent: 'invoiceManager',
                  httpObj: JSON.stringify({ orderNumber: row.id })
            }
          });

          console.log(targetRoute.href,'看时刻打开')
          window.open(targetRoute.href, '_blank');
      }
    },
    //开发票
    invoiceClick(val) {
      let obj = JSON.parse(JSON.stringify(val))
      obj.orderMainId = obj.id
      this.detailList.forEach(item => {
        this.$set(item, 'orderMainId', item.id)
      })
      obj.payPrice = Number(obj.payPrice) - Number(obj.refundPrice) - Number(obj.invoicePrice)
      this.$refs.invoicePopup.init(obj)
    },
    deleteCollection(item) {
      new PayApi("pay").deleteData({ collectionId: item.id }).then(res => {
        if (res.status == 200) {
          this.$message.success("删除成功")
          this.getList()
        }
      }).catch(e => {
        this.$message.error(res.statusText)
      })
    },
    deleteDetailData(item) {
      new PayApi("pay").deleteDetailData({ collectionDetailId: item.id }).then(res => {
        if (res.status == 200) {
          this.$message.success("删除成功")
          this.getList(item.collectionId)
        }
      }).catch(e => {
        this.$message.error(res.statusText)
      })
    },
    sendMessageToWechat(id){
      new ApplyApi('apply').firstSendApproval(id,1).then(res => {
        if (res.status == 200) {
          this.$message.success({ message: "微信公众号审核提醒发送成功" })
        } else {
          this.$message.error({ message: res.statusText })
        }
      })
    },
    refuceSure() {
      if (this.refuceObj.payType == 2) {
        new PayApi("pay").refundData(this.refuceObj).then(res => {
          if (res.status == 200) {
            this.$message.success("退款申请成功")
            //首选要发起审核
            new OrderApi('order').orderPayRequestApplyDai(res.data).then(res1 => {
              if (res1.status == 200) {
                this.$message.success({ message: "已成功发起审批" })
                this.dialogVisible2 = false;
                this.sendMessageToWechat(res.data)
              } else {
                this.$message.error({ message: res1.statusText })
              }
            })
            this.refuceObj.status = 3
          }
        })
      } else {
        new PayApi("pay").collectionRefund({ collectionDetailId: this.refuceObj.id,price:this.refuceObj.price,
          remark:this.refuceObj.remark
        }).then(res => {
          if (res.status == 200) {
            this.$message.success("退款申请成功")
            item.status = 3
          }
        })
      }
      
    },
    refurePay(item) {
      this.dialogVisible2 = true
      this.refuceObj.id = item.id
      this.refuceObj.payType = item.payType
      if (this.refuceObj.payType == 2) {
        new PayApi("pay").selectBlanceData({ collectionDetailId: item.id }).then(res => {
          if (res.status == 200) {
            var number = res.data.accountName.replace(/[^\d]/g, " ").trim();
            this.refuceObj.payBankName = res.data.accountName.replace(number, "")
            this.refuceObj.payBankNumber = number;
            this.refuceObj.payName = res.data.majorCategories
          }
        }).catch(e => {
          this.$message.error("系统异常，退款失败")
        })
      }
    },
    refreshDetailData(list) {
      this.detailList = list
      this.detailList = this.detailList.sort((a, b) => b.payDate - a.payDate)
      this.detailListObj.totalPrice = 0;
      this.detailListObj.incomePrice = 0;
      this.detailListObj.waitIncomePrice = 0;
      this.detailListObj.noIncomePirce = 0;
      this.detailListObj.refurePrice = 0;
      this.detailListObj.refureingPrice = 0;
      this.detailListObj.taxPrice = 0;
      this.detailList.forEach(ee => {
        if (ee.status != 5 && ee.status != 6) {
          this.detailListObj.totalPrice = this.detailListObj.totalPrice + ee.payPrice
        }
        if (ee.status == 0) {
          this.detailListObj.noIncomePirce = this.detailListObj.noIncomePirce + ee.payPrice
        } else if (ee.status == 1) {
          this.detailListObj.incomePrice = this.detailListObj.incomePrice + ee.payPrice
        } else if (ee.status == 2) {
          this.detailListObj.waitIncomePrice = this.detailListObj.waitIncomePrice + ee.payPrice
        } else if (ee.status == 3) {
          if (ee.refurePrice == 0) {
            this.detailListObj.refureingPrice = this.detailListObj.refureingPrice + ee.payPrice
          } else {
            this.detailListObj.incomePrice = this.detailListObj.incomePrice + (ee.payPrice - ee.refundPrice)
            this.detailListObj.refureingPrice = this.detailListObj.refureingPrice + ee.refundPrice
          }
        } else if (ee.status == 4) {
          if (ee.refurePrice == 0) {
            this.detailListObj.refurePrice = this.detailListObj.refurePrice + ee.payPrice
          } else {
            this.detailListObj.incomePrice = this.detailListObj.incomePrice + (ee.payPrice - ee.refundPrice)
            this.detailListObj.refurePrice = this.detailListObj.refurePrice + ee.refundPrice
          }
        } else {
          if (ee.status == 5) {
            this.detailListObj.incomePrice = this.detailListObj.incomePrice - ee.payPrice
            this.detailListObj.taxPrice = this.detailListObj.taxPrice + ee.payPrice
          } else {
            this.detailListObj.incomePrice = this.detailListObj.incomePrice + ee.payPrice
            this.detailListObj.taxPrice = this.detailListObj.taxPrice - ee.payPrice
          }
        }
      })
    },
    serachList() {
      var arr = []
      this.tableData.forEach(ee => {
        ee.collectionDetailList.forEach(eee => {
          this.$set(eee, 'currency', ee.currency)
          if (this.detailSearchObj.status) {
            if (this.detailSearchObj.status == 1) {
              if (eee.status == 1 || eee.status == 2 || eee.status == 4 || eee.status == 5 || eee.status == 6) {
                arr.push(eee)
              }
            } else {
              if (eee.status == 0 || eee.status == 3) {
                arr.push(eee)
              }
            }
          } else {
            arr.push(eee)
          }
        })
      })
      this.refreshDetailData(arr)
    },
    handlerSeeOrderClick1(type) {
      this.dialogVisible1 = !this.dialogVisible1
      if (this.dialogVisible1) {
        var arr = []
        this.tableData.forEach(ee => {
          ee.collectionDetailList.forEach(eee => {
            if (type==0 || type == 1) {
              if (type == 1) {
                if (eee.status != 0) {
                  arr.push(eee)
                }
              }
              if (type == 0) {
                if (eee.status == 0) {
                  arr.push(eee)
                }
              }
            } else {
              arr.push(eee)
            }
          })
        })
        this.refreshDetailData(arr)
      }
    },
    handlerSeeOrderClick(item) {
      this.detailId = item.id
      this.dialogVisible1 = true
      this.refreshDetailData(item.collectionDetailList)
    },
    loadTable(page, size) {
      this.page = page;
      this.size = size;
      this.getList()
    },
    addUnderLinePay(item) {
      this.$refs.addUnderLonePay.openDailog(item)
    },
    getList(id, type) {//type 1 是已收  2 是全部 0 是代收
      new PayApi("pay").collectionList({
        page: this.page, size: this.size, q: {
          planId: this.planId,
        }
      }).then(res => {
        if (res.status == 200) {
          this.tableData = res.data.records
          if (type == 1||type == 0) {
            this.handlerSeeOrderClick1(type)
          }
          this.totalNumber = res.data.total
          this.tableData.forEach(e => {
            var number = 0;
            if (id) {
              if (e.id == id) {
                this.refreshDetailData(e.collectionDetailList)
              }
            }
            e.collectionDetailList.forEach(ee => {
              if (ee.status == 1) {
                number++;
              }
            })
            this.$set(e, 'payNumber', number)
          })
        }
      })
    },
    uploadFile(item,flag) {
      this.$refs.addUnderLonePay.openDailog1(item,flag)
    }
  }
}
</script>

<style lang="scss" scoped>
.payRequestContent {
  >p {
    >span {
      width: 90px;
      display: inline-block;
    }

    >div {
      width: 200px;
    }

    margin-top: 10px;
  }
}

.searchDiv {
  margin-bottom: 0.1rem;

  >div {
    margin-right: 0.1rem;
  }
}

.footer {
  .footTitle {
    height: 0.5rem;
    border: 1px solid #ebeef5;
    padding: 0 0.4rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: none;

    .footTitleLeft {
      display: flex;
      align-items: center;

      .p1 {
        margin-right: 0.2rem;
        font-size: 0.16rem;
        font-weight: bold;
        color: #000;
      }
    }
  }
}

.totalPrice {
  margin-left: 10px;

  >span {
    color: red;
  }
}
</style>